import { AxiosResponse } from 'axios';

import {
  IBulkExerciseStatusRequest,
  ICreateExerciseStatusRequest,
  IEducationProgressResponse,
  IExerciseStatusRecord,
  IUpdateExerciseStatusRequest,
} from './education-progress.interface';

import { axiosApiInstance } from 'services/config';

class EducationProgressApi {
  async getEducationProgressByAccount(
    accountId: number,
  ): Promise<IEducationProgressResponse> {
    const response: AxiosResponse<IEducationProgressResponse> =
      await axiosApiInstance.get(`education-progress/account/${accountId}`);
    return response.data;
  }

  async getEducationProgressByKnowledgeArea(
    accountId: number,
    knowledgeAreaId: number,
  ): Promise<IEducationProgressResponse> {
    const response: AxiosResponse<IEducationProgressResponse> =
      await axiosApiInstance.get(
        `education-progress/account/${accountId}/knowledge-area/${knowledgeAreaId}`,
      );
    return response.data;
  }

  async createExerciseStatus(
    requestData: ICreateExerciseStatusRequest,
  ): Promise<IExerciseStatusRecord> {
    const response: AxiosResponse<IExerciseStatusRecord> = await axiosApiInstance.post(
      'education-progress',
      requestData,
    );
    return response.data;
  }

  async updateExerciseStatus(
    id: number,
    requestData: IUpdateExerciseStatusRequest,
  ): Promise<IExerciseStatusRecord> {
    const response: AxiosResponse<IExerciseStatusRecord> = await axiosApiInstance.put(
      `education-progress/${id}`,
      requestData,
    );
    return response.data;
  }

  async createExerciseStatusesBulk(
    requestData: IBulkExerciseStatusRequest[],
  ): Promise<IExerciseStatusRecord[]> {
    const response: AxiosResponse<IExerciseStatusRecord[]> = await axiosApiInstance.post(
      'education-progress/bulk',
      requestData,
    );
    return response.data;
  }

  async updateExerciseStatusesBulk(
    requestData: IBulkExerciseStatusRequest[],
  ): Promise<IExerciseStatusRecord[]> {
    const response: AxiosResponse<IExerciseStatusRecord[]> = await axiosApiInstance.put(
      'education-progress/bulk',
      requestData,
    );
    return response.data;
  }
}

export { EducationProgressApi };
